"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TABLE_ROW = exports.TABLE_HEADER = exports.TABLE = exports.ITEM_CELL_MAX_LINES = exports.HEADER_CELL_MAX_LINES = exports.CELL_MIN_WIDTH = exports.CELL_MAX_WIDTH = void 0;
const CELL_MIN_WIDTH = exports.CELL_MIN_WIDTH = 150;
const CELL_MAX_WIDTH = exports.CELL_MAX_WIDTH = 300;
const HEADER_CELL_MAX_LINES = exports.HEADER_CELL_MAX_LINES = 2;
const ITEM_CELL_MAX_LINES = exports.ITEM_CELL_MAX_LINES = 4;
const TABLE = exports.TABLE = 'table';
const TABLE_ROW = exports.TABLE_ROW = 'table-row';
const TABLE_HEADER = exports.TABLE_HEADER = 'table-header';
